module.exports = __webpack_public_path__ + "img/c5202009-6.1ce21719.jpg";